module.exports = __webpack_public_path__ + "static/media/d15e1c3e-e5b9-4d05-a5e0-cc9e833ab2b2.8ec62740.JPG";